/**
 * Vuex actions for the "siwfauth" module.
 *
 * Retrieves "Sign In With Farcaster" (SIWF) data for the current session.
 */
import { authErrorHandler } from '@/services/errorServices/authHandler.js';
import { getUserFriendlyErrorMessage } from '@/helpers/errorHandlerHelper.js';
import router from '@/router';

export default {
  /**
   * Fetch SIWF data via `getUserHandle` and return it (or `null` on error,
   * after routing the error through `authErrorHandler`). Does not commit any
   * mutation with the result.
   */
  fetchSiwfData({ commit }, payload) {
    try {
      const siwfData = getUserHandle(commit, payload).then(data => data);
      return siwfData;
    } catch (error) {
      const friendlyMessage = getUserFriendlyErrorMessage(error);
      console.error('Error fetching SIWF data from cookie:', friendlyMessage);
      
      // In development, also log the original error for debugging
      if (import.meta.env.MODE === 'development') {
        console.error('Original SIWF error:', error);
      }
      
      authErrorHandler(error);
      return null;
    }
  },
};

/**
 * Currently a stub: always returns `null` without making a request. The
 * original implementation (querying `/api/siwf/handle`, handling deleted/
 * unauthorized accounts, and committing `setSiwfData`) is left commented out
 * below rather than removed.
 */
async function getUserHandle(commit, payload) {
  // const { fromUsername, toUsername } = payload || {};
  // if (!fromUsername || !toUsername)
  //   return null;
  return null;
  // const usernameQuery = fromUsername && toUsername ? `?fromUsername=${encodeURIComponent(fromUsername)}&toUsername=${toUsername}` : '';
  // const response = await fetch(`/api/siwf/handle${usernameQuery}`, {
  //   method: 'GET',
  //   headers: {
  //     'content-type': 'application/json',
  //   },
  //   credentials: 'include',
  // });

  // if (!response) {
  //   const error = new Error('No response received');
  //   throw new Error(error.message || 'failed to get user frequency handle.');
  // }

  // const siwfData = await response.json();
  //   if (siwfData?.message === "User account is deleted" || siwfData?.message === "User no longer exists" || siwfData?.message === "Unauthorized" ) {
  //     await fetch("/api/auth/logout", {
  //       method: "POST",
  //       credentials: "include",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     localStorage.removeItem("user");
  //     localStorage.removeItem("activeTab");
  //     commit("setAuthStatus", false);
  //     await router.push("/");
  //     return;
  //   }
  // commit('setSiwfData', siwfData);
  // localStorage.setItem('userFrequencyHandle', siwfData?.userDetails?.frequencyHandle.baseHandle);

  // return siwfData;
}
